import { UnwrapError } from './mhtml.js';
import { bytesToBinary } from './bytes.js';

/** Apple ikili plist (bplist00) okuyucu — WebArchive için gereken alt küme: null/bool, int, real, date, data, string, uid, array, dict. */
export function parseBplist(bytes: Uint8Array): unknown {
  const magic = bytesToBinary(bytes.subarray(0, 8));
  if (magic !== 'bplist00' || bytes.length < 40) throw new UnwrapError('BAD_PLIST', 'Dosya bir ikili plist değil');
  const dv = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
  const t = bytes.length - 32;
  const offSize = bytes[t + 6]!, refSize = bytes[t + 7]!;
  const numObjects = Number(dv.getBigUint64(t + 8));
  const topObject = Number(dv.getBigUint64(t + 16));
  const tableOffset = Number(dv.getBigUint64(t + 24));
  const readUInt = (pos: number, size: number): number => { let v = 0; for (let i = 0; i < size; i++) v = v * 256 + bytes[pos + i]!; return v; };
  const offsets: number[] = [];
  for (let i = 0; i < numObjects; i++) offsets.push(readUInt(tableOffset + i * offSize, offSize));
  const readLen = (pos: number, low: number): [number, number] => {
    if (low !== 0x0f) return [low, pos + 1];
    const m = bytes[pos + 1]!; const size = 1 << (m & 0x0f);
    return [readUInt(pos + 2, size), pos + 2 + size];
  };
  const cache = new Map<number, unknown>();
  const parseAt = (idx: number): unknown => {
    if (cache.has(idx)) return cache.get(idx);
    const pos = offsets[idx]!; const b = bytes[pos]!; const type = b >> 4, low = b & 0x0f;
    let val: unknown;
    switch (type) {
      case 0x0: val = low === 0x08 ? false : low === 0x09 ? true : null; break;
      case 0x1: val = readUInt(pos + 1, 1 << low); break;
      case 0x2: val = low === 3 ? dv.getFloat64(pos + 1) : dv.getFloat32(pos + 1); break;
      case 0x3: val = new Date((dv.getFloat64(pos + 1) + 978307200) * 1000); break;
      case 0x4: { const [n, s] = readLen(pos, low); val = bytes.slice(s, s + n); break; }
      case 0x5: { const [n, s] = readLen(pos, low); val = bytesToBinary(bytes.subarray(s, s + n)); break; }
      case 0x6: { const [n, s] = readLen(pos, low); let str = ''; for (let i = 0; i < n; i++) str += String.fromCharCode(dv.getUint16(s + i * 2)); val = str; break; }
      case 0x8: val = { uid: readUInt(pos + 1, low + 1) }; break;
      case 0xa: { const [n, s] = readLen(pos, low); const arr: unknown[] = []; cache.set(idx, arr); for (let i = 0; i < n; i++) arr.push(parseAt(readUInt(s + i * refSize, refSize))); val = arr; break; }
      case 0xd: {
        const [n, s] = readLen(pos, low); const obj: Record<string, unknown> = {}; cache.set(idx, obj);
        for (let i = 0; i < n; i++) { const k = parseAt(readUInt(s + i * refSize, refSize)); const v = parseAt(readUInt(s + (n + i) * refSize, refSize)); obj[String(k)] = v; }
        val = obj; break;
      }
      default: throw new UnwrapError('BAD_PLIST', `Desteklenmeyen plist nesne türü ${type}`);
    }
    cache.set(idx, val);
    return val;
  };
  return parseAt(topObject);
}
